<template>
  <modal :show="show" :large="true" v-on:close="closeModal">
    <div slot="title">
      <h4>Add Overpayment</h4>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <datepicker-input
            name="overpayment_date"
            label="Overpayment Date"
            helper="Please enter the overpayment date"
            v-model="form.overpayment_date"
          ></datepicker-input>

          <currency-input
            name="overpayment_value"
            label="Overpayment Amount"
            :value="form.value"
            @input="updateOverpaymentValue"
          ></currency-input>

          <input-block
            name="comment"
            label="Overpayment Comment"
            v-model="form.comment"
          ></input-block>

          <datepicker-input
            name="return_date"
            label="Overpayment Return Date"
            helper="Please enter the overpayment return date"
            v-model="form.return_date"
          ></datepicker-input>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button type="button" v-on:click="closeModal" class="btn btn-danger">
        Close
      </button>
      <form-button :indicator="form.processing()" v-on:clicked="addOverpayment">
        Add Overpayment
      </form-button>
    </div>
  </modal>
</template>
<script>
import CurrencyInput from '@/components/Generic/Form/CurrencyInput';

export default {
  components: {
    CurrencyInput
  },

  props: {
    incident: {
      type: String,
      required: true
    },
    recovery: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      form: new window.Form({
        overpayment_date: null,
        value: 0,
        comment: null,
        return_date: null
      })
    };
  },

  watch: {
    'form.return_date'(val) {
      if (val) {
        this.form.value = 0;
      }
    }
  },

  methods: {
    updateOverpaymentValue(value) {
      this.form.value = value;
    },

    closeModal() {
      this.$emit('close');
    },

    addOverpayment() {
      this.form
        .post(`/debt-recovery/${this.incident}/overpayments`)
        .then(response => {
          window.toastify.success(
            'Success',
            'The overpayment was added successfully!'
          );
          this.closeModal();

          this.form.overpayment_date = null;
          this.form.value = 0;
          this.form.comment = null;
          this.form.return_date = null;
        })
        .catch(error => {
          window.toastify.error(
            'Sorry, there was a problem adding the overpayment'
          );
        });
    }
  }
};
</script>
